import BasketStorage from "./../../../src/app/pages/Basket/Component/BasketStorage";
//import ApiBasketPerson from "../api/api.basketPerson";
import ApiBasket from "../api/api.basket";
import _ from "lodash";
import moment from "moment-jalaali";

const makeStorageId = () => {
  let storageId =
    moment().format("jYYYYjMMjDDHHmmss") +
    (Math.random() + 1).toString().substring(3, 8);
  return storageId;
};

export const BasketHelper = {
  addItemToBasket: async (
    ctx,
    totalCount,
    originalPrice,
    price,
    amusementServiceId,
    amusementServiceName,
    amusementServiceImageUrl,
    amusementPlaceId,
    amusementPlaceName,
    checkInDate,
    details,
    basketItemPersons,
    fieldId,
    itemId,
    itemGroupId,
    agentPaidAmount,
    commissionAmount,
    maxCount,
    minCount
  ) => {
    let basketStorage = BasketStorage.getBasket();
    let basketStorage_ItemStorageId = null;

    if (_.isEmpty(basketStorage)) {
      basketStorage = { basketItemTemps: [] }; // مقداردهی اولیه در صورت خالی بودن
    }

    let index = basketStorage.basketItemTemps.findIndex(
      (e) =>
        e.originalPrice === originalPrice &&
        e.salePrice === price &&
        e.amusementServiceId === amusementServiceId &&
        e.amusementPlaceId === amusementPlaceId &&
        e.checkInDate === checkInDate &&
        e.details === details &&
        e.isDeleted === false &&
        e.amusementServiceReserveItemGroupId === itemGroupId &&
        e.amusementServiceReserveItemId === itemId
    );
    if (index !== -1) {
      basketStorage_ItemStorageId =
        basketStorage.basketItemTemps[index].storageId;
      let oldTotalCount = basketStorage.basketItemTemps[index].totalCount;
      let newTotalCount = totalCount;

      basketStorage.basketItemTemps[index].totalCount = newTotalCount;
      basketStorage.basketItemTemps[index].sumOriginalPrice =
        originalPrice * newTotalCount;
      basketStorage.basketItemTemps[index].sumPrice =
        (agentPaidAmount) * newTotalCount;

      if (newTotalCount > oldTotalCount) {
        for (let i = 0; i < newTotalCount - oldTotalCount; i++) {
          basketStorage.basketItemTemps[index].basketItemPersonTemps.push(
            basketItemPersons[0]
          );
        }
      } else {
        for (let i = 0; i < oldTotalCount - newTotalCount; i++) {
          basketStorage.basketItemTemps[index].basketItemPersonTemps.pop();
        }
      }
      if (basketStorage.basketItemTemps[index].totalCount == 0) {
        basketStorage.basketItemTemps[index].isDeleted = true;
        basketStorage.basketItemTemps[index].sumOriginalPrice = 0;
        basketStorage.basketItemTemps[index].sumPrice = 0;
        basketStorage.basketItemTemps[index].sumSalePrice = 0;
      }
    } else {
      let basketItem = {
        id: 0,
        totalCount: totalCount,
        sumOriginalPrice: originalPrice * totalCount,
        sumPrice: (agentPaidAmount) * totalCount,
        sumSalePrice: price * totalCount,
        amusementServiceId: amusementServiceId,
        amusementPlaceId: amusementPlaceId,
        checkInDate: checkInDate,
        amusementServiceName: amusementServiceName,
        amusementServiceImageUrl: amusementServiceImageUrl,
        amusementPlaceName: amusementPlaceName,
        details: details,
        isDeleted: false,
        basketItemPersonTemps: basketItemPersons,
        fieldId: fieldId,
        storageId: basketStorage_ItemStorageId
          ? basketStorage_ItemStorageId
          : makeStorageId(),
        amusementServiceReserveItemId: itemId,
        amusementServiceReserveItemGroupId: itemGroupId,
        agentPaidAmount: agentPaidAmount,
        commissionAmount: commissionAmount,
        maxCount: maxCount,
        minCount: minCount,
      };
      basketStorage.basketItemTemps.push(basketItem);
    }

    let basketStorageOriginalPrice = 0,
      basketStoragePrice = 0,
      basketStorageSalePrice = 0;

    basketStorage.basketItemTemps.forEach((item) => {
      basketStorageOriginalPrice += item.sumOriginalPrice;
      basketStoragePrice += item.sumPrice;
      basketStorageSalePrice += item.sumSalePrice;
    });

    basketStorage.originalPrice = basketStorageOriginalPrice;
    basketStorage.price = basketStoragePrice;
    basketStorage.salePrice = basketStorageSalePrice;

    // ذخیره‌ی سبد خرید به‌روز شده
    BasketStorage.setBasket(basketStorage);
    ctx.setbasketInfo(basketStorage);
  },
  getBasket: async (ctx) => {
    // سبد خرید را از استورج بردار اگر خالی نیست بفرست برای سرور
    const resultBasketStorage = BasketStorage.getBasket(); //ctx.basketInfo;

    let basket2 = {};
    if (!_.isEmpty(resultBasketStorage)) {
      basket2 = resultBasketStorage;

      // بررسی basketItemPersons
      if (
        !_.isEmpty(BasketStorage.getBasketPerson()) &&
        BasketStorage.getBasketPerson().length >= 0
      ) {
        basket2.basketItemTemps?.forEach((item) => {
          item.basketItemPersonTemps?.forEach((item2) => {
            if (
              !_.isNumber(item2.basketPersonId) ||
              item2.basketPersonId == 0
            ) {
              let indexItem = BasketStorage.getBasketPerson().findIndex(
                (e) => e.indexId == item2.basketPersonIdIndex
              );
              if (indexItem !== -1) {
                item2.basketPersonId =
                  BasketStorage.getBasketPerson()[indexItem].id;
                item2.basketPersonIdIndex =
                  BasketStorage.getBasketPerson()[indexItem].indexId;
              }
            }
          });
        });
      }
    }
    // گرفتن سبد و یا ترکیب دو سبد
    // const response = await ApiBasket.putAddOrEditeBasket(basket2);
    // if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
    //   // قرار دادن سبد خرید دریافتی در استوریج
    //   BasketStorage.setBasket(response.data);
    //   // قرار دادن سبد در کانتکس
    //   ctx.setbasketInfo(response.data);
    //   return response.data;
    // }
    return null;
  },
  getBasketFromStorage: async (ctx) => {
    const resultBasketStorage = BasketStorage.getBasket();
    // console.log("BasketStorageget=",resultBasketStorage);

    if (!_.isEqual(resultBasketStorage, ctx.basketInfo))
      ctx.setbasketInfo(resultBasketStorage);
    return resultBasketStorage;
  },
  changeBasketItemTotalCount: async (
    ctx,
    basketItem,
    basketItemCount,
    permissionToDelete = false
  ) => {
    try {
      let basket = BasketStorage.getBasket();
      // تغییرات لیست ایتم های سبد خرید
      let index = -1;
      if (basketItem.id > 0)
        index = basket.basketItemTemps.findIndex(
          (e) => e.storageId == basketItem.storageId
        );
      else
        index = basket.basketItemTemps.findIndex((e) =>
          _.isEqual(e, basketItem)
        );
      // index = basket.basketItemTemps.findIndex(e => e.amusementServiceId == basketItem.amusementServiceId && e.amusementPlaceId == basketItem.amusementPlaceId && e.checkInDate == basketItem.checkInDate && e.originalPrice == basketItem.originalPrice && e.price == basketItem.price);
      if (index != -1) {
        // delete/add  basketItemPerson
        let lastElement =
          basket.basketItemTemps[index].basketItemPersonTemps[
          basket.basketItemTemps[index].basketItemPersonTemps.length - 1
          ]; // basket.basketItemTemps[index].basketItemPersonTemps.slice(-1)[0];
        if (basketItemCount > basketItem.totalCount) {
          //add
          let lastBasketItemPerson = {};
          lastBasketItemPerson.id = 0;
          lastBasketItemPerson.basketTempId = lastElement.basketTempId;
          lastBasketItemPerson.basketItemTempId = lastElement.basketItemTempId;
          lastBasketItemPerson.basketPersonId = lastElement.basketPersonId;
          lastBasketItemPerson.basketPersonIdIndex =
            lastElement.basketPersonIdIndex;
          lastBasketItemPerson.basketPersonPersonFullName =
            lastElement.basketPersonPersonFullName;
          lastBasketItemPerson.amount = lastElement.amount;
          basket.basketItemTemps[index].basketItemPersonTemps.push(
            lastBasketItemPerson
          );
        }
        if (basketItemCount < basketItem.totalCount) {
          //delete
          basket.basketItemTemps[index].basketItemPersonTemps.pop();
        }

        // change basketItem
        if (
          permissionToDelete &&
          basketItemCount < basket.basketItemTemps[index].minReserveCount
        )
          basket.basketItemTemps[index].totalCount = 0;
        else basket.basketItemTemps[index].totalCount = basketItemCount; //basketItem.totalCount;
        if (basket.basketItemTemps[index].totalCount == 0) {
          basket.basketItemTemps[index].isDeleted = true;
          basket.basketItemTemps[index].sumOriginalPrice = 0;
          basket.basketItemTemps[index].sumPrice = 0;
          basket.basketItemTemps[index].sumSalePrice = 0;
        } else {
          basket.basketItemTemps[index].sumOriginalPrice =
            basketItem.originalPrice * basketItemCount;
          basket.basketItemTemps[index].sumPrice =
            (basketItem.agentPaidAmount) * basketItemCount;
          basket.basketItemTemps[index].sumSalePrice =
            basketItem.salePrice * basketItemCount;
        }
        // تغییرات سبد خرید
        basket.originalPrice = basket.basketItemTemps.reduce(
          (a, v) => (a = a + v.sumOriginalPrice),
          0
        );
        basket.price = basket.basketItemTemps.reduce(
          (a, v) => (a = a + v.sumPrice),
          0
        );
        basket.salePrice = basket.basketItemTemps.reduce(
          (a, v) => (a = a + v.sumSalePrice),
          0
        );
        BasketStorage.setBasket(basket);
        // قرار دادن سبد در کانتکس
        ctx.setbasketInfo(basket);
        //-----------------------------------------------------------------
        //ارسال سبد خرید استورج و ترکیب دو سبد
        let response = null;
        try {
          // response = await ApiBasket.putAddOrEditeBasket(basket);
        } catch { }
        if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
          // قرار دادن سبد خرید دریافتی در استوریج
          BasketStorage.setBasket(response.data);
          // قرار دادن سبد در کانتکس
          ctx.setbasketInfo(response.data);
        } else {
          ctx.setbasketInfo(BasketStorage.getBasket());
        }
      } else {
      }
      //-----------------------------------------------------------------
    } catch (error) { }
  },
  deletebasketItem: async (ctx, basketItem) => {
    let basket = BasketStorage.getBasket(); //ctx.basketInfo;
    // console.log("BasketStoragedele=",basket);
    // console.log("basketItem=",basketItem);

    // تغییرات لیست ایتم های سبد خرید
    let index = -1;
    if (basketItem.id > 0)
      index = basket.basketItemTemps.findIndex((e) => e.id == basketItem.id);
    else
      index = basket.basketItemTemps.findIndex((e) => _.isEqual(e, basketItem));
    // console.log("basket.basketItemTemps=",basket.basketItemTemps);
    // index = basket.basketItemTemps.findIndex(e => e.amusementServiceId == basketItem.amusementServiceId && e.amusementPlaceId == basketItem.amusementPlaceId && e.checkInDate == basketItem.checkInDate && e.originalPrice == basketItem.originalPrice && e.price == basketItem.price);
    // alert(index);
    if (index !== -1) {
      basket.basketItemTemps[index].isDeleted = true;
      basket.basketItemTemps[index].sumOriginalPrice = 0;
      basket.basketItemTemps[index].sumPrice = 0;
      // props.item.isDeleted = true;

      // تغییرات سبد خرید
      basket.originalPrice = basket.basketItemTemps.reduce(
        (a, v) => (a = a + v.sumOriginalPrice),
        0
      );
      basket.price = basket.basketItemTemps.reduce(
        (a, v) => (a = a + v.sumPrice),
        0
      );
      BasketStorage.setBasket(basket);
      ctx.setbasketInfo(basket);
      //-----------------------------------------------------------------
      //ارسال سبد خرید استورج و ترکیب دو سبد
      //const response = await ApiBasket.putAddOrEditeBasket(basket);

      //if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
      //  // قرار دادن سبد خرید دریافتی در استوریج
      //  BasketStorage.setBasket(response.data);
      //  // قرار دادن سبد در کانتکس
      //  ctx.setbasketInfo(response.data);
      //}
    } else {
    }
  },
  getBasketPersonList: async (ctx) => {
    // لیست اشخاص را از استورج بردار اگر خالی نیست بفرست برای سرور
    const resultBasketStorage = BasketStorage.getBasketPerson(); //ctx.basketPersonInfo;

    let basketPerson2 = [];
    if (!_.isEmpty(resultBasketStorage)) {
      basketPerson2 = resultBasketStorage;
    }
    return null;
  },
  addBasketPersonList: async (ctx, basketPersonListInput) => {
    // 1. بررسی ورودی
    if (_.isEmpty(basketPersonListInput) || basketPersonListInput.length <= 0) {
      return []; // بازگشت آرایه خالی به جای undefined
    }

    // 2. دریافت لیست موجود از storage
    let existingPersons = BasketStorage.getBasketPerson() || [];
    let updatedList = [...existingPersons]; // ایجاد کپی

    // 3. پردازش ورودی‌های جدید
    const newPersons = [];

    basketPersonListInput.forEach((inputItem) => {
      if (!inputItem.personFullName) return;

      const existingIndex = existingPersons?.findIndex(
        (e) => e.personFullName === inputItem.personFullName
      );

      if (existingIndex !== -1) {
        // به‌روزرسانی آیتم موجود
        inputItem.id = existingPersons[existingIndex].id;
        inputItem.indexId = existingPersons[existingIndex].indexId;
      } else {
        // افزودن آیتم جدید
        newPersons.push(inputItem);
      }
    });

    // 4. ترکیب لیست‌ها (فقط افراد جدید اضافه شوند)
    const result = [...newPersons];

    // 5. ذخیره در storage (اختیاری)
    if (newPersons.length > 0) {
      BasketStorage.setBasketPerson([...existingPersons, ...newPersons]);
    }

    // 6. بازگشت فقط افراد جدید/به‌روز شده
    return result;
  },
  deletebasket: async (ctx) => {
    try {
      let basket = {};
      console.log("basket", basket);
      // قرار دادن سبد خرید دریافتی در استوریج
      BasketStorage.setBasket(basket);
      // قرار دادن سبد در کانتکس
      ctx.setbasketInfo(basket);
    } catch { }
  },
  getBasketOfDB: async (ctx) => {
    // گرفتن سبد از دیتا بیس
    const response = await ApiBasket.getBasketTemp();
    //شاید بهتر باشد سبد استورچ را با دیتا بیس بررس کند و اگر تفاوتی بود یکسان سازی انجام دهد؟؟

    if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
      // // قرار دادن سبد خرید دریافتی در استوریج
      // BasketStorage.setBasket(response.data);
      // // قرار دادن سبد در کانتکس
      // ctx.setbasketInfo(response.data);
      return response.data;
    }
    return null;
  },
  addPromoCodeToBasket: async (ctx, insertedPromoCode) => {
    let basketStorage = BasketStorage.getBasket();
    if (!_.isEmpty(basketStorage)) {
      basketStorage.insertedPromoCode = insertedPromoCode;
    } else {
      basketStorage = { insertedPromoCode: insertedPromoCode };
    }
    //const basket = await ApiBasket.putAddOrEditeBasket(basketStorage);
    //if (!_.isEmpty(basket) && !_.isEmpty(basket.data)) {
    //  // قرار دادن سبد خرید دریافتی در استوریج
    //  BasketStorage.setBasket(basket.data);
    //  // قرار دادن سبد در کانتکس
    //  ctx.setbasketInfo(basket.data);
    //  return basket.data;
    //} else return basketStorage;
  },
  changeBasketItemPerson: async (ctx, oldPerson, newPerson) => {
    let basket = BasketStorage.getBasket();
    basket?.basketItemTemps?.map((basketItemTemps) => {
      basketItemTemps?.basketItemPersonTemps.map((basketItemPersonTemps) => {
        if (
          basketItemPersonTemps.basketPersonPersonFullName ===
          oldPerson.basketPersonPersonFullName
        ) {
          basketItemPersonTemps.basketPersonId = newPerson.basketPersonId;
          basketItemPersonTemps.basketPersonPersonFullName =
            newPerson.basketPersonPersonFullName;
        }
      });
    });
    //const serverBasket = await ApiBasket.putAddOrEditeBasket(basket);
    //if (!_.isEmpty(serverBasket) && !_.isEmpty(serverBasket.data)) {
    //  // قرار دادن سبد خرید دریافتی در استوریج
    //  BasketStorage.setBasket(serverBasket.data);
    //  // قرار دادن سبد در کانتکس
    //  ctx.setbasketInfo(serverBasket.data);
    //}
  },
};
